import { render, staticRenderFns } from "./IntegratedSalesComparisonView.vue?vue&type=template&id=4af7ff24&scoped=true"
import script from "./IntegratedSalesComparisonView.vue?vue&type=script&lang=js"
export * from "./IntegratedSalesComparisonView.vue?vue&type=script&lang=js"
import style0 from "./IntegratedSalesComparisonView.vue?vue&type=style&index=0&id=4af7ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af7ff24",
  null
  
)

export default component.exports